// @flow
import {
  FETCH_ADVERTISERS_BEGIN,
  FETCH_ADVERTISERS_SUCCESS,
  FETCH_ADVERTISERS_FAILURE,
} from "../actions/advertisers";

import type { Action } from "../actions/advertisers";

export type State = {
  items: Map<number, string>,
  loading: boolean,
  error: Object,
};

const INITIAL_STATE: State = {
  items: new Map(),
  loading: false,
  error: null,
};

export default function reducer(state: State = INITIAL_STATE, action: Action): State {
  switch (action.type) {
    case FETCH_ADVERTISERS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ADVERTISERS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.advertisers.reduce((acc, { _id, name }) => {
          acc.set(_id, name);

          return acc;
        }, new Map()),
      };
    case FETCH_ADVERTISERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}
